import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { API_URL, isFieldError, setValToLS } from "../helpers";
import "./styles.css";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Select from "../components/Select";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const FriendsSignup = () => {
  const [charities, setCharities] = useState([]);
  const [names, setNames] = useState({});
  const [errors, setErrors] = useState([]);
  const [msg, setMsg] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const history = useHistory();
  const formElement = useRef(null);

  const query = new URLSearchParams(useLocation().search);

  useEffect(() => {
    init();

    // eslint-disable-next-line
  }, []);

  const init = async () => {
    const url = new URL(`${API_URL}/friendsSignupInit`);
    const params = {
      code: query.get("code") || "",
    };
    url.search = new URLSearchParams(params);

    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setCharities([...json.charities]);
        if (json.charityId) {
          handleUpdate("charityId", json.charityId);
        }
        setAlert({});
      } else {
        setAlert({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/friendsSignup`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      data.append(key, value);
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setValToLS("friendsDash", json.token, true);
        history.push("/friends/dash");
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <div id="full-column">
      <Hdg section="Friendraising" />
      <>
        {alert.type ? (
          <Alert data={alert} />
        ) : (
          <>
            <h3>
              <i className="fa fa-user-plus" /> &nbsp;Create Account
            </h3>

            <p>
              Use the form below to create an account to become a “friendraiser”
              for raising funds on behalf of a specifc charity.
            </p>

            <p style={{ marginBottom: "15px" }}>
              Should you have any questions, please contact{" "}
              <a href="mailto:stephanie@valerotexasopen.com">
                Stephanie@ValeroTexasOpen.com
              </a>{" "}
              or at 210.345.3839.
            </p>

            <form
              ref={formElement}
              method="post"
              action="/"
              onSubmit={(e) => handleSubmit(e)}
              className="well"
            >
              <h3 style={{ marginTop: "0" }}>Enter Account Information</h3>

              <div className="form-group">
                <Input
                  name="fname"
                  label="First Name"
                  reqd={true}
                  value={names.fname || ""}
                  update={handleUpdate}
                  errors={errors}
                  autocomplete="given-name"
                />
                <Input
                  name="lname"
                  label="Last Name"
                  reqd={true}
                  value={names.lname || ""}
                  update={handleUpdate}
                  errors={errors}
                  autocomplete="family-name"
                />
              </div>

              <div className="form-group">
                <Input
                  name="email"
                  label="Email Address"
                  reqd={true}
                  value={names.email || ""}
                  update={handleUpdate}
                  errors={errors}
                />
                <Input
                  name="confirm"
                  label="Confirm Email"
                  reqd={true}
                  value={names.confirm || ""}
                  update={handleUpdate}
                  errors={errors}
                  autocomplete="off"
                />
              </div>

              <div className="form-group">
                <Select
                  name="charityId"
                  label="Select Charity"
                  reqd={true}
                  value={names.charityId || ""}
                  options={charities}
                  update={handleUpdate}
                  error={isFieldError(errors, "charityId")}
                />
                <div className="empty" />
              </div>

              <div className="msg-submit">
                {msg.type && <Msg data={msg} />}

                <div
                  className={
                    msg.type === "working" || msg.type === "success"
                      ? "hidden"
                      : "submit-container"
                  }
                >
                  <Submit
                    path="/friends/signin"
                    left="Sign In"
                    submit="Create Account"
                  />
                </div>
              </div>
            </form>
          </>
        )}
      </>
    </div>
  );
};

export default FriendsSignup;
